// ES
export const derivedRatesSection = {
  title: "Tarifas derivadas",
  description:
    "Crea tarifas basadas en tus rate plans principales para conectar con diferentes OTAs manteniendo un precio base centralizado.",
  newRate: "Nueva tarifa derivada",
  loading: "Cargando tarifas...",

  otaBadge: "OTA",
  otaLockedTitle: "Tarifa de OTA: se gestiona desde 'Conectar OTA'",
  salePaused: "Venta pausada",

  columns: {
    name: "Nombre",
    adjustment: "Ajuste",
    finalPrice: "Precio Final",
  },

  actions: {
    resumeTitle: "Reanudar ventas en Channex",
    pauseTitle: "Pausar ventas en Channex (stop_sell)",
    edit: "Editar",
    delete: "Eliminar",
    protectedTitle: "Protegida: cámbiala o quítala desde 'Conectar OTA'",
  },

  empty: {
    title: "No hay tarifas derivadas",
    text: "Crea tarifas derivadas basadas en tus rate plans principales para conectar con OTAs",
    create: "Crear Primera Tarifa Derivada",
  },

  modal: {
    editTitle: "Editar tarifa derivada",
    createTitle: "Nueva tarifa derivada",
    baseRatePlan: "Rate Plan Base",
    selectBasePlaceholder: "Selecciona un rate plan base",
    selectBaseHint:
      "Selecciona el rate plan sobre el cual se calculará esta tarifa derivada",
    nameLabel: "Nombre de la tarifa derivada",
    namePlaceholder: "Ej: Tarifa Booking.com, Tarifa Airbnb",
    nameHint: "Este nombre te ayudará a identificar la tarifa al conectar con OTAs",
    adjustmentType: "Tipo de ajuste",
    percentage: "Porcentaje",
    fixedAmount: "Monto Fijo",
    adjustmentValue: "Valor del ajuste",
    adjustmentValueHint: "(usa valores negativos para descuentos)",
    cancel: "Cancelar",
    saving: "Guardando...",
    update: "Actualizar",
    create: "Crear Tarifa",
  },

  preview: {
    title: "Vista Previa",
    basePrice: "Precio base",
    increment: "Incremento",
    discount: "Descuento",
    finalPrice: "Precio final",
  },

  delete: {
    title: "Eliminar tarifa derivada",
    warnStrong: "Esta acción no se puede deshacer.",
    warnText:
      "Antes de eliminar, asegúrate de que la tarifa {name} no esté vinculada con ninguna OTA.",
    confirmLabel: "Escribe el nombre exacto para confirmar:",
    confirmPlaceholder: "Escribe exactamente el nombre de la tarifa",
    confirmHint:
      "Pega o escribe el nombre tal cual aparece arriba para habilitar el botón de eliminar.",
    cancel: "Cancelar",
    processing: "Eliminando...",
    confirm: "Eliminar definitivamente",
  },

  pause: {
    resumeTitle: "Reanudar ventas",
    pauseTitle: "Pausar ventas",
    resumeText:
      "Se enviará {code} a Channex para los próximos 500 días. El canal volverá a recibir disponibilidad y podrá aceptar reservas.",
    pauseText:
      "Se enviará {code} a Channex para los próximos 500 días. El canal vinculado a esta tarifa no podrá aceptar nuevas reservas mientras esté pausada.",
    note: "El calendario principal y otros canales no se verán afectados. Para reanudar, haz clic en el botón ▶ de la tarifa.",
    cancel: "Cancelar",
    resuming: "Reanudando...",
    pausing: "Pausando...",
    confirmResume: "Sí, reanudar ventas",
    confirmPause: "Sí, pausar ventas",
  },

  toast: {
    loadError: "Error al cargar los datos",
    fillRequired: "Por favor completa todos los campos requeridos",
    updated: "Tarifa actualizada exitosamente",
    created: "Tarifa creada exitosamente",
    saveFailed: "No se pudo guardar la tarifa",
    saveError: "Error al guardar la tarifa derivada",
    deleted: "Tarifa derivada eliminada",
    deleteFailed: "No se pudo eliminar la tarifa",
    deleteLinkedOta: "No se puede eliminar: la tarifa está vinculada a una OTA.",
    nameMismatch: "El nombre ingresado no coincide.",
    deleteError: "Error eliminando la tarifa derivada",
    salesPaused: "Ventas pausadas",
    salesResumed: "Ventas reanudadas",
    toggleFailed: "No se pudo cambiar el estado",
    toggleError: "Error al cambiar el estado de la tarifa",
    // Guardada en local, pero Channex no aceptó el cambio (channex_synced:false).
    channexNotSynced: "La tarifa se guardó, pero el channel manager no aceptó el cambio: los canales siguen con lo que tenían. Revisa los datos e inténtalo de nuevo.",
  },

  // Estancia mínima propia de una derivada (own_min_stay). Campo y chip
  // compartidos: OwnMinStayField.vue / OwnMinStayChip.vue.
  ownMinStay: {
    label: "Estancia mínima propia (noches)",
    hint: "Vacío = la misma que la tarifa principal",
    mixedPlaceholder: "Varios",
    mixedHint: "Cada habitación tiene un mínimo distinto. Si escribes uno, se aplicará a todas; si lo dejas vacío, cada una conserva el suyo.",
    // Sugerencia por el nombre («Tarifa semanal» → 7): una pregunta de un clic.
    suggestQuestion: "¿Mínimo {n} noche? | ¿Mínimo {n} noches?",
    suggestUse: "Usar",
    clear: "Quitar",
    channelNote: "{channel} recibirá un mínimo de {n} noche para esta tarifa. | {channel} recibirá un mínimo de {n} noches para esta tarifa.",
    genericNote: "Los canales conectados (Booking, etc.) recibirán un mínimo de {n} noche para esta tarifa. | Los canales conectados (Booking, etc.) recibirán un mínimo de {n} noches para esta tarifa.",
    chip: "Mín. {n} noche | Mín. {n} noches",
    chipMixed: "Mín. distinto por habitación",
    chipTitle: "Estancia mínima propia de esta tarifa: se envía a los canales conectados",
    // Grupo con mínimos distintos: quitárselo a todas es un gesto aparte.
    clearAll: "Quitar el mínimo a todas",
    clearedAllHint: "Al guardar, todas perderán su mínimo propio y usarán el de la tarifa principal.",
    undo: "Deshacer",
  },
};
